/**
 * Contract lifecycle statuses (`contracts.status`).
 *
 * The vocabulary itself now lives in **`@wtc/contract-signing`**, together with
 * the awaiting-signature set, the display labels, the outstanding-signer
 * derivation and the staleness rule — because Hub's table, the contract detail
 * tab, the Slack deal card and the iOS chase screen were each deriving those
 * independently and one of them had already drifted.
 *
 * This module stays as the Hub-facing re-export so every existing
 * `@/lib/constants/contract-statuses` import keeps working, including the tuple
 * that `validate-tool-enum-constants` reads to keep the Meridian
 * `list_contracts` filter enum honest.
 */

import {
  CONTRACT_SIGNING_STATUSES,
  type ContractSigningStatus,
} from "@west-tennessee-consulting/contract-signing";

export const CONTRACT_STATUS_VALUES = CONTRACT_SIGNING_STATUSES;

export type ContractStatus = ContractSigningStatus;

export type {
  ContractChaseTier,
  ContractSigningRow,
  ContractSigningState,
  ContractStatusPresentation,
  ContractStatusTone,
} from "@west-tennessee-consulting/contract-signing";

export {
  AWAITING_SIGNATURE_STATUSES,
  CONTRACT_STATUS_PRESENTATION,
  contractStatusLabel,
  contractStatusTone,
  isAwaitingSignature,
  isSignedStatus,
  isTerminalStatus,
  summarizeContractSigning,
  toContractSigningStatus,
} from "@west-tennessee-consulting/contract-signing";
